import axios from 'axios';
import routes from 'app/routes';

export const Actions = {
  load: (dispatch, filters) => {
    const params = {};
    if (filters.affiliateId) {
      params['q[affiliate_id_eq]'] = filters.affiliateId;
    }
    axios.get(
      routes.api.affiliates.payments.index,
      { params },
    ).then((resp) => {
      dispatch({ type: 'load', payments: resp.data.data });
    });
  },

  pay: (dispatch, paymentId) => {
    axios.post(routes.api.affiliates.payments.pay(paymentId)).then((resp) => {
      dispatch({ type: 'pay', payment: resp.data.data });
    });
  },
};
